import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

import useAuth from 'common/hooks/useAuth';
import { useTrackingPixelQuery } from 'common/apollo/graphql';
import { env } from 'utils/env';

TagManager.initialize({
  gtmId: env.GTM_CONTAINER_ID as string,
  auth: env.GTM_AUTH,
  preview: env.GTM_ENV,
});

function TrackingPixel(): null {
  const { isAuthenticated } = useAuth();
  const { data: { me } = {} } = useTrackingPixelQuery({
    skip: !isAuthenticated,
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (me) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ct.identify',
          userId: me?.id as string,
          name: me?.name,
          role: me?.role,
          email: me?.email,
        },
      });
    }
  }, [me]);

  return null;
}

export default TrackingPixel;
